import * as React from 'react';
import { FlowType } from '../../../../services/userflow/UserFlowService';
import { BootstrapPage } from './BootstrapPage';

interface BootstrapLoginPageProps {
  location: Location;
}

const BootstrapIFrameLoginPage: React.SFC<BootstrapLoginPageProps> = ({ location }) => {
  return <BootstrapPage flow={FlowType.iFrameLogin} location={location} />;
};

export { BootstrapIFrameLoginPage };
